import React from 'react';
import { AwardIcon, UsersIcon, TrendingUpIcon } from 'lucide-react';
export function Proof() {
  return <section className="py-16 border-t border-black" data-id="element-224">
      <div className="grid md:grid-cols-2 gap-12" data-id="element-225">
        <div data-id="element-226">
          <h2 className="text-2xl font-bold mb-8 flex items-center" data-id="element-227">
            <AwardIcon className="h-8 w-8 text-orange-500 mr-2" data-id="element-228" />
            Credibilidad Comprobada
          </h2>
          <div className="bg-black/30 p-6 rounded-lg mb-6" data-id="element-229">
            <div className="mb-4" data-id="element-230">
              <h3 className="text-xl font-bold mb-2" data-id="element-231">Gabriel Beltrán</h3>
              <ul className="space-y-3" data-id="element-232">
                <li className="flex items-start" data-id="element-233">
                  <TrendingUpIcon className="h-5 w-5 text-green-400 mr-2 flex-shrink-0 mt-1" data-id="element-234" />
                  <span data-id="element-235">$50M en ventas personales</span>
                </li>
                <li className="flex items-start" data-id="element-236">
                  <TrendingUpIcon className="h-5 w-5 text-green-400 mr-2 flex-shrink-0 mt-1" data-id="element-237" />
                  <span data-id="element-238">$500M generados por estudiantes</span>
                </li>
                <li className="flex items-start" data-id="element-239">
                  <UsersIcon className="h-5 w-5 text-green-400 mr-2 flex-shrink-0 mt-1" data-id="element-240" />
                  <span data-id="element-241">
                    Ha presentado en escenarios con +50,000 emprendedores en
                    EE.UU y LATAM
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="bg-black/30 p-6 rounded-lg" data-id="element-242">
            <h3 className="text-xl font-bold mb-4" data-id="element-243">Datos del Mercado</h3>
            <p className="mb-4" data-id="element-244">
              Según Statista, el 80% de las marcas DTC ya invierten en IA para
              marketing.
              <span className="font-bold text-orange-400" data-id="element-245">
                {' '}
                No hacerlo hoy es quedarse atrás.
              </span>
            </p>
            <div className="h-4 bg-gray-700 rounded-full mb-2" data-id="element-246">
              <div className="h-4 bg-orange-500 rounded-full" style={{
              width: '80%'
            }} data-id="element-247"></div>
            </div>
            <p className="text-sm text-gray-400" data-id="element-248">
              80% de marcas exitosas ya usan IA en marketing
            </p>
          </div>
        </div>
        <div data-id="element-249">
          <h2 className="text-2xl font-bold mb-8 flex items-center" data-id="element-250">
            <UsersIcon className="h-8 w-8 text-orange-500 mr-2" data-id="element-251" />
            Resultados Reales
          </h2>
          <div className="space-y-6" data-id="element-252">
            <div className="bg-black/30 p-6 rounded-lg" data-id="element-253">
              <div className="flex items-center mb-4" data-id="element-254">
                <div className="w-12 h-12 bg-orange-800 rounded-full flex items-center justify-center text-xl font-bold mr-4" data-id="element-255">
                  FL
                </div>
                <div data-id="element-256">
                  <h3 className="font-bold" data-id="element-257">Freelancers</h3>
                  <p className="text-orange-300 text-sm" data-id="element-258">
                    Copywriters y Marketers
                  </p>
                </div>
              </div>
              <p data-id="element-259">
                "Duplicaron ingresos entregando VSLs y funnels en días, no
                semanas."
              </p>
            </div>
            <div className="bg-black/30 p-6 rounded-lg" data-id="element-260">
              <div className="flex items-center mb-4" data-id="element-261">
                <div className="w-12 h-12 bg-orange-800 rounded-full flex items-center justify-center text-xl font-bold mr-4" data-id="element-262">
                  TO
                </div>
                <div data-id="element-263">
                  <h3 className="font-bold" data-id="element-264">Tiendas Online</h3>
                  <p className="text-orange-300 text-sm" data-id="element-265">eCommerce y DTC</p>
                </div>
              </div>
              <p data-id="element-266">"Redujeron 70% en costos de contenido y duplicaron ventas."</p>
            </div>
            <div className="bg-black/30 p-6 rounded-lg" data-id="element-267">
              <div className="flex items-center mb-4" data-id="element-268">
                <div className="w-12 h-12 bg-orange-800 rounded-full flex items-center justify-center text-xl font-bold mr-4" data-id="element-269">
                  AF
                </div>
                <div data-id="element-270">
                  <h3 className="font-bold" data-id="element-271">Afiliados</h3>
                  <p className="text-orange-300 text-sm" data-id="element-272">
                    Marketing de Afiliación
                  </p>
                </div>
              </div>
              <p data-id="element-273">
                "Pasaron de perder dinero a escalar globalmente con un solo VSL
                creado con IA."
              </p>
            </div>
            <p className="text-center font-bold text-lg" data-id="element-274">
              Más de 500+ emprendedores ya han aplicado estos prompts y reportan
              resultados inmediatos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}